import { Box, LinearProgress, Pagination, Typography } from '@mui/material';
import {
  DataGrid,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { findOnArray } from 'utils/functions';
import localeText from 'utils/localeText';
import moment from 'moment';
import styles from './styles';

const DetalhesModal = ({ item }) => {
  const CustomPagination = () => {
    const gridRef = useGridApiContext();
    const count = useGridSelector(gridRef, gridPageCountSelector);
    return (
      <Pagination
        color="primary"
        count={count}
        onChange={(_, value) => gridRef?.current?.setPage(value - 1)}
      />
    );
  };

  return (
    <Box sx={styles?.container}>
      <DataGrid
        rows={item?.Conferidos || []}
        columns={[
          {
            field: 'referencia',
            headerName: 'Referência',
            width: 150,
            sortable: false,
            renderCell: () => (
              <Typography variant="body2">{item?.referencia}</Typography>
            ),
          },
          {
            field: 'descricao',
            headerName: 'Produto',
            minWidth: 400,
            flex: 1,
            sortable: false,
            renderCell: () => (
              <Typography variant="body2">{item?.descricao}</Typography>
            ),
          },
          ...(item?.variavel === 'SIM'
            ? [
                {
                  field: 'variacao_id',
                  headerName: 'Variação',
                  width: 200,
                  sortable: false,
                  renderCell: ({ value }) => (
                    <Typography variant="body2">
                      {findOnArray(value, drops?.ProdutoVariacao, 'label')}
                    </Typography>
                  ),
                },
              ]
            : []),
          ...(item?.rastreavel === 'SIM'
            ? [
                {
                  field: 'rastreabilidade',
                  headerName: 'Rastreabilidade',
                  width: 200,
                  sortable: false,
                },
                {
                  field: 'validade',
                  headerName: 'Validade',
                  type: 'date',
                  width: 200,
                  sortable: false,
                  valueGetter: ({ value }) =>
                    value ? moment(value, 'YYYY-MM-DD').toDate() : null,
                  renderCell: ({ value }) => (
                    <Typography variant="body2">
                      {value
                        ? moment(value, 'YYYY-MM-DD')?.format('DD/MM/YYYY')
                        : ''}
                    </Typography>
                  ),
                },
              ]
            : []),
          {
            field: 'quantidade',
            headerName: 'Quantidade',
            type: 'number',
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
              <Typography variant="body2">
                {row?.quantidade || 0} {item?.unidade_medida || ''}
              </Typography>
            ),
          },
        ]}
        density="compact"
        disableColumnMenu
        showCellRightBorder
        showColumnRightBorder
        disableSelectionOnClick
        localeText={localeText}
        components={{
          LoadingOverlay: LinearProgress,
          Pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default DetalhesModal;
